import React from 'react';
import Navbar from './Navbar/Navbar';
import AnimatedBackground from "./AnimatedBackground/AnimatedBackground";
import WhatsappIcon from "./WhatsappIcon/WhatsappIcon";

function Layout({ children }) {
  return (
    <div>
      <AnimatedBackground />
      <Navbar />
      <WhatsappIcon />
      <main>{children}</main>
    </div>
  );
}

export default Layout;
